import React from "react";
import PropTypes from "prop-types";

import StandardAccordionGallery from "./StandardAccordionGallery";
import ComponentMissing from "../../Debug/ComponentMissing";

const AccordionGallerySwitcher = ({
  layout,
  header,
  headerType,
  headerDisplayStyle,
  headerLink,
  headerLinkType,
  secondaryLink,
  secondaryLinkType,
  subline,
  teaser,
  id,
  accordionCards,
  animation,
}) => {
  const properties = {
    header,
    headerType,
    headerDisplayStyle,
    headerLink,
    headerLinkType,
    secondaryLink,
    secondaryLinkType,
    subline,
    teaser,
    id,
    accordionCards,
    animation,
  };

  function switchAccordionGallery() {
    switch (layout) {
      case "standard":
        return <StandardAccordionGallery properties={properties} />;
      default:
        return <ComponentMissing type="AccordionGallery" subType={layout} />;
    }
  }

  return switchAccordionGallery();
};

AccordionGallerySwitcher.propTypes = {
  layout: PropTypes.string,
  header: PropTypes.string,
  headerType: PropTypes.string,
  headerDisplayStyle: PropTypes.string,
  headerLink: PropTypes.oneOfType([PropTypes.instanceOf(Object), PropTypes.string]),
  headerLinkType: PropTypes.string,
  secondaryLink: PropTypes.oneOfType([PropTypes.instanceOf(Object), PropTypes.string]),
  secondaryLinkType: PropTypes.string,
  subline: PropTypes.string,
  teaser: PropTypes.string,
  id: PropTypes.number,
  accordionCards: PropTypes.instanceOf(Array),
  animation: PropTypes.instanceOf(Object),
};

export default AccordionGallerySwitcher;
